export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;

  function modifyTitle(data) {
    const text = data.items[0].Title;
    const subTitle = text.split('-')[0];
    const title = text.split('-')[1];
    const fullTitle = `<h2 aria-label="${subTitle} ${title}">${subTitle}<span>${title}</span></h2>`;

    $(`#${widgetName} .card-widget-title`).html(fullTitle);
    $(`#${widgetName} .moreButton`).addClass('button');
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function (data) {
      modifyTitle(data);
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'Learn More',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false,
  });
}
